import React, { useState } from "react";
import {
  MoreVertical,
  Folder as FolderIcon,
  Edit3,
  Trash2,
  CornerDownRight,
} from "react-feather";

interface FolderProps {
  name: string;
  path: string;
  totalFiles?: number;
  usedFiles?: number;
  onEnter: (path: string) => void;
  onRename?: (path: string, newName: string) => void;
  onDelete?: (path: string) => void;
  onMove?: (path: string) => void;
}

export function Folder({
  name,
  path,
  totalFiles = 0,
  usedFiles = 0,
  onEnter,
  onRename,
  onDelete,
  onMove,
}: FolderProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(name);

  const handleRename = () => {
    if (onRename && editName.trim() && editName !== name) {
      onRename(path, editName.trim());
    }
    setIsEditing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleRename();
    } else if (e.key === "Escape") {
      setEditName(name);
      setIsEditing(false);
    }
  };

  return (
    <div className="folder-item mb-2 bg-base-200 rounded-lg border border-base-300 hover:bg-base-300 transition-colors cursor-pointer ">
      <div className="flex items-center justify-between">
        <div
          onClick={() => onEnter(path)}
          className="flex items-center p-3 gap-3 flex-1"
        >
          <div className="text-2xl">
            <FolderIcon size={14} />
          </div>
          {isEditing ? (
            <input
              type="text"
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              onBlur={handleRename}
              onKeyDown={handleKeyPress}
              className="input input-sm bg-base-100 flex-1 max-w-xs"
              autoFocus
            />
          ) : (
            <div className="flex justify-between flex-1">
              <span className="font-medium">{name}</span>
              <div className="flex items-center gap-2">
                <div className="badge badge-xs badge-neutral border-0 overflow-hidden relative">
                  <div
                    className="bg-accent h-full absolute top-0 left-0 z-index-0"
                    style={{ width: `${(usedFiles / totalFiles) * 100}%` }}
                  />
                  <span className="relative z-index-10">
                    {usedFiles}/{totalFiles} used
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="flex gap-1 pr-3">
          <div className="dropdown dropdown-end">
            <div
              tabIndex={0}
              role="button"
              className="btn btn-xs btn-ghost m-0 px-0"
            >
              <MoreVertical size={14} />
            </div>
            <ul
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-box z-1 w-30 p-2 shadow-sm"
            >
              {onRename && (
                <li>
                  <span onClick={() => setIsEditing(true)}>
                    <Edit3 size={14} /> Rename
                  </span>
                </li>
              )}
              {onMove && (
                <li>
                  <span onClick={() => onMove(path)}>
                    <CornerDownRight size={14} /> Move
                  </span>
                </li>
              )}
              {onDelete && (
                <li>
                  <span onClick={() => onDelete(path)}>
                    <Trash2 size={14} /> Delete
                  </span>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
